import { ReportCardType } from "features/production/models/RegistrationMark";

export type ReportProcessingType = 'sms' | 'whatsApp' | 'email'; 


export type _RecipientType = 'direct' | 'filter';

export type RecipientFilterOriginType = '' | 'registration' | 'reportCard' |'teacher' | 'parent' | 'supplier';


export interface IReportProcessing {
    id: number,

    reportDocumentId: number,
    entityId: number,
    jobScheduleId: number,
    validityStartDate: Date,
    validityEndDate: Date,

    type: ReportProcessingType,

    messageBody: string,
    // for manage message for instant messaging...
    messageBodyFR: string,
    messageBodyEN: string,

    messageObject: string,
    // for manage message for instant messaging...
    messageObjectFR: string,
    messageObjectEN: string,

    reportRecipient: string,
    
    base64Report: string,
    reportFileName: string,

    // for manage message for instant messaging...
    base64ReportFR: string,
    reportFileNameFR: string,
    base64ReportEN: string,
    reportFileNameEN: string,

    isProcessed: boolean,
    lastProcessingError: string,
    processingDate: Date,

    currentRecipientLanguage: string,
    reportRecipientsWithLanguage: {recipient: string, language: string}[],
    reportRecipients: string[],
    currentRecipient: string,

    directMessageInfos: IDirectMessageInfo[],

    countRecipient: number,
    countDistinctRecipient: number,


    isTemplateMessage: boolean,
    reportId: number,
    reportName: string,

    // for instant messaging.....
    recipientType: _RecipientType,

    recipientFilterOrigin: RecipientFilterOriginType,


    recipientSource: 'portable' | 'email',
    languageSource: string,

    schoolYearId: number,
    studyType: string,
    studySection: string,
    studyLanguage: string,
    studyCycle: string,
    studyLevel: string,
    schoolYearClassTemplateId: number,
    schoolYearClassId: number,
    gender: '' | 'F' | 'M',

    oldStudentStatus: '' | 'Y' | 'N', // all, old, new
    repeaterStatus: '' | 'Y' | 'N', // all, repeater, not repeater.
    socialCaseStatus: '' | 'Y' | 'N', // all, social case, not social case
    hasDeparted: boolean,

    amountToPayType: '' | 'U' | 'D', // Unpaid, Due.
    dueDate: Date,

    reportCard: string,
    reportCardType: ReportCardType,
    schoolYearPeriodId: number,
    schoolYearPeriodExamId: number,

    countRegistration: number,
}


export interface IDirectMessageInfo {
  recipient: string,
  language: string,
  //variablesObj?: Record<string, string | number | undefined>;
  variablesObj?: Record<string, string | number | undefined>,
  //[key: string]: string | number | undefined; // allows template variables
}


export const defaultReportProcessing : IReportProcessing = {
    id: 0,

    reportDocumentId: 0,
    entityId: 0,
    jobScheduleId: 0,
    validityStartDate: new Date(),
    validityEndDate: new Date(),

    type: 'sms',

    messageBody: '',

    messageBodyFR: '',
    messageBodyEN: '',

    messageObject: '',

    messageObjectFR: '',
    messageObjectEN: '',

    reportRecipient: '',
    
    base64Report: '',
    reportFileName: '',

    base64ReportFR: '',
    reportFileNameFR: '',
    base64ReportEN: '',
    reportFileNameEN: '',


    isProcessed: false,
    lastProcessingError: '',
    processingDate: new Date(),

    currentRecipientLanguage: '',
    reportRecipientsWithLanguage: [],
    reportRecipients: [],
    currentRecipient: '',

    directMessageInfos: [],

    countRecipient: 0,
    countDistinctRecipient: 0,


    isTemplateMessage: false,
    reportId: 0,
    reportName: '',


    recipientType: 'direct',

    recipientFilterOrigin: 'registration',

    recipientSource: 'portable',
    languageSource: 'fr-FR',

    schoolYearId: 0,
    studyType: '',
    studySection: '',
    studyLanguage: '',
    studyCycle: '',
    studyLevel: '',
    schoolYearClassTemplateId: 0,
    schoolYearClassId: 0,
    gender: '',

    oldStudentStatus: '',
    repeaterStatus: '',
    socialCaseStatus: '',
    hasDeparted: false,

    amountToPayType: '', // Unpay, Due.
    dueDate: new Date(),

    
    reportCard: '',
    reportCardType: 'exam',
    schoolYearPeriodId: 0,
    schoolYearPeriodExamId: 0,

    countRegistration: 0
}

export interface IReportProcessingSearch {
    messageBody: string,
    reportRecipient: string

}